module.exports = __webpack_public_path__ + "static/media/background.fde957c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/background.png
// module id = 2226
// module chunks = 228